import React from 'react';
import { Box } from '@mui/system';
import styled from '@emotion/styled'
import { Button, Typography, Card } from '@mui/material';

const BackgroundStyle = styled(Box)`
  background-color: #FFFFFF;
  background-size: cover;
  margin: 20px;
  height: 100%;

  // width: calc(100vw - 56px); /* Subtract double the margin to account for both sides */
  // height: calc(100vh - 56px); /* Subtract double the margin to account for both top and bottom */
  // @media (min-width: 1680px) {
  //   /* Styles for small screens */
  //   height: calc(100vh - 56px);
}
`;

const LightBlueContainer = styled(Box)`
  border-radius: 20px;
  background-color: #EAF4FF;
  height: 100%;
  width: 100%;
`;

const ListContainer = styled(Box)`
  // position: relative;
  border-radius: 20px;
  background-color: #EAF4FF;
  height: 100%;
  // width: 100%;
  display: flex;
  flex-direction: column;
`;

const EntryDetailStyle = styled(Box)`
  height: 42vh;
  border-radius: 20px;
  // overflow: auto;
  background-color: #FFFFFF;
  width: 95%;
  position: relative;
  margin-left: 20px;
`;

const NavyButton = styled(Button)`
  background: linear-gradient(180deg, #0F2C57, #082652);
  font-weight: bold;
  height: 70px;
  width: 100px;
  padding: 10px;
  border-radius: 10px;
  color: white;
  text-transform: none;
`;

const BlueButton = styled(Button)`
  background: linear-gradient(180deg, #124188, #083F92);
  font-weight: bold;
  height: 70px;
  width: 100px;
  padding: 10px;
  border-radius: 10px;
  color: white;
  text-transform: none;
`;


const RedButton = styled(Button)`
  background: linear-gradient(180deg, #EC8686, #ED6464);
  font-weight: bold;
  min-width: 100px;
  // padding: 10px;
  border-radius: 5px;
  color: white;
  text-transform: none;
  margin-left:16px;
  // margin-top:18px;
  margin-right: auto;
  @media (max-width: 480px) {
    /* Styles for small screens */
    margin-left:0px;
}
`;

const AddEquipmentButton = styled(Button)`
  background: linear-gradient(180deg, #5F84BA, #486DA5);
  font-weight: bold;
  width: 268px;
  border-radius: 5px;
  color: white;
  text-transform: none;
  margin-left:16px;
  // margin-top:18px;
  margin-right: auto;
  @media (max-width: 480px) {
    /* Styles for small screens */
    margin-left:0px;
}
`;

const LongBlueButton = styled(Button)`
  background: linear-gradient(180deg, #5F84BA, #486DA5);
  font-weight: bold;
  width: 268px;
  padding: 10px;
  border-radius: 5px;
  color: white;
  text-transform: none;
  margin-left:20px;
  margin-bottom:10px;
`;

const ShortBlueButton = styled(Button)`
  background: linear-gradient(180deg, #5F84BA, #486DA5);
  font-weight: bold;
  min-width: 120px;
  border-radius: 5px;
  color: white;
  text-transform: none;
  margin-left:28px;
  margin-bottom:10px;
  maxWidth: 20px;
  // @media (max-width: 480px) {
  //   /* Styles for small screens */
  //   margin-left:28px;
`;

const DocumentButton = styled(Button)`
  background: linear-gradient(180deg, #5F84BA, #486DA5);
  font-weight: bold;
  min-width: 120px;
  border-radius: 5px;
  color: white;
  text-transform: none;
  // margin-left:28px;
  margin-bottom:10px;
  // maxWidth: 20px;
  @media (max-width: 1080px) {
    /* Styles for small screens */
    margin-left:20px;
    margin-right:50px;
}
`;

const BackButton = styled(Button)`
  background: linear-gradient(180deg, #7B7B7B, #909090);
  font-weight: bold;
  min-width: 120px;
  border-radius: 5px;
  color: white;
  text-transform: none;
  margin-left:28px;
  margin-bottom:10px;
  maxWidth: 20px;
`;

const DeleteButton = styled(Button)`
  // background: linear-gradient(180deg, #7B7B7B, #909090);
  background: linear-gradient(180deg, #EC8686, #ED6464);
  font-weight: bold;
  min-width: 120px;
  border-radius: 5px;
  color: white;
  text-transform: none;
  margin-left:28px;
  margin-bottom:10px;
  maxWidth: 20px;
`;

const BigHeading = styled(Typography)`
    font-weight: bold;
    padding: 5px;
    // font-size: 12px;
    margin-left: 24px;
    margin-top: 20px;
    font-size: calc(18px + 0.2vw);
    font-family: 'Poppins', sans-serif;
    text-decoration: underline;
    // min-height: 4%;
`;

const HeadingTitle = styled(Typography)`
    font-weight: light;
    padding: 5px;
    margin-left: 24px;
    // margin-top: 20px;
    color: white;
    font-size: calc(18px + 0.2vw);
    font-family: 'Poppins', sans-serif;
    // text-decoration: underline;
`;

const SmallHeading = styled(Typography)`
    // padding: 5px;
    // font-size: 12px;
    margin-left: 52px;
    font-size: calc(10px + 0.3vw);
    font-family: 'Poppins', sans-serif;
    // text-decoration: underline;
    // min-height: 4%;
`;

const WorkerDetailTextField = styled(Typography)`
    // padding: 5px;
    // font-size: 12px;
    margin: 18px;
    font-size: calc(8px + 0.3vw);
    font-family: 'Poppins', sans-serif;
    // min-height: 4%;
`;

const EntryTextField = styled(Typography)`
    padding: 5px;
    // font-size: 12px;
    margin-left: 24px;
    font-size: calc(8px + 0.3vw);
    font-family: 'Poppins', sans-serif;
    // min-height: 4%;
`;

const MapContainer = styled.div`
    // border-style: solid;
    // border-radius: 2px;
    display: flex;
    flex-direction: row;
    width: 100vw;
    height: 100vh;
    // border-color: #124188;
`;

const SmallMapContainer = styled.div`
    // border-style: solid;
    // border-radius: 2px;
    width: 50vw;
    // border-color: #124188;
    height: 100vh;
`;

const RecordTableContainer = styled(Box)`
  overflow: auto;
  // max-height: calc(100% - 270px);
  margin: 28px;
  flex-grow: 1;
  background: #FFFFFF;
  border-radius: 20px;
  position: relative;
  // height: 100%;
`;

// const FlexContainer = styled.div`
//   display: flex;
//   align-items: center;
//   @media (max-width: 768px) {
//     /* Styles for small screens */
//     flex-wrap: wrap;
//   }
// `;
const FlexContainer = styled.div`
  display: flex;
  width: 100%;
  // flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  // @media (max-width: 768px) {
  //   /* Styles for small screens */
  //   flex-wrap: wrap;
  //   flex-direction: column;
  //   // justify-content: center;
  // }
`;
const SearchingBoxContainer = styled(Box)`

  margin: 28px;
  border-radius: 10px;
  // @media (max-width: 800px) {
  //   margin: 10px;
  // }
`;

const BlueBox = styled.div`
  // width: 100%;
  background-color: #f7fbff;
  padding: 5px;
  border-radius: 30px;
  box-shadow: 0px 5px 15px rgba(180, 219, 255, 1);
  // margin-bottom: 5px;
  // margin-left:20px;
`;

const SearchContainer = styled.div`
  // width: 100%;
  // background-color: white;
  border-radius: 30px;
  margin-left: 20px;
  margin-top: 20px;
  // padding-top: 5px;
  // padding-bottom: 5px;
`;

const HidddenButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const LabelContainer = styled.label`
  width: 200px;
  margin-left: 20px;
  @media (max-width: 1080px) {
    /* Styles for small screens */
    width: 160px;
  }
  flex-wrap: wrap;
`;

const LongLabelContainer = styled.label`
  width: 300px;
  margin-left: 20px;
  @media (max-width: 1080px) {
    /* Styles for small screens */
    width: 160px;
  }
  flex-wrap: wrap;
`;

const NavigationContainer = styled(Box)`
  height: 62px;
  flex-direction: row;
  background-color: white;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

const NavigationSideContainer = styled(Box)`
  display: flex;
  align-items: center;
  height: 30px;
`;
// const BarContainer = styled(Box)`
//   display: flex;
//   // align-items: center;
//   height: 30px;
//   border-radius: 10px;
//   background-color: white;
//   display:row;
// `;
const BarContainer = styled(Box)`
  display: flex;
  align-items: center;
  min-height: 30px;
  border-radius: 10px;
  background-color: white;
  flex-wrap: wrap;
`;

const BarLabel = styled(Box)`
  margin-left: 40px;
  @media (max-width: 768px) {
    /* Styles for small screens */
    margin-left:20px;
`;

const WhiteContainer = styled(Box)`
  display: flex;
  // align-items: center;
  // height: 430px;
  border-radius: 10px;
  background-color: white;
  display:row;
  flex-wrap: wrap;
  // min-width: 320px;
`;

const FormWhiteContainer = styled(Box)`
  // display: flex;
  // align-items: center;
  // height: 430px;
  border-radius: 10px;
  background-color: white;
  margin-left:28px;
  margin-right:28px;
  // display:row;
  // flex-wrap: wrap;
  // min-width: 320px;
  margin-bottom: 10px;
`;
const ButtonContainer = styled(Box)`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  flex-wrap: wrap;
`;

const StyledLink = styled.a`
  margin-left: 10px;

  @media (max-width: 1440px) {
    margin-left: 20px;
    // display: block;
    // margin-top: 10px;
  }
`;
const StyledIconButton = styled.button`
  margin-left: 10px;

  @media (max-width: 360px) {
    margin-left: 50px;
    // display: block;
    // margin-top: 10px;
  }
`;

const WorkDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 500px;
`;

const MapBigCardContainer = styled(Card)`
  height: 100%;
  border-radius: 10px;
  lineHeight: 1;
  width: 100%;
  min-height: 300px;
  min-width: 100px;
  display: flex;
  //margin-left: 10px;
  //margin-top: 10px;
  @media (max-width: 960px){
    flex-direction: column;
    min-width: 200px;
    min-height: 200px;
    height: 100%;
  }
`;

const MapSmallCardContainer = styled(Card)`
  border-radius: 16px;
  lineHeight: 1;
  width: 20vw;
  // min-height: 500px;
  min-height: 550px;
  min-width: 560px;
  display: flex;
  margin-left: 10px;
  margin-top: 10px;
  @media (max-width: 768px){
    width: 72vw;
    min-width: 100%;
    margin-left: 0px;
    //max-width: 240px;
  }
`;

const MapBigBoxContainer = styled(Box)`
  height: 96%;
  width: 45%;
  margin-left: 20px;
  margin-top: 20px;
  display: flex;
  @media (max-width: 960px){
    min-width: 100%;
    order: 2;
  }
`;

const MapBigMapBoxContainer = styled(Box)`
  height: 100%;
  width: 53%;
  margin-right: 20px;
  margin-top: 20px;
  @media (max-width: 960px){
    width:100%;
    order: 1;
    margin-left: 5px;
    margin-right: 5px;
  }
`;

const MapSmallMapBoxContainer = styled(Box)`
  height: 100%;
  width: 100%;
  margin-right: 20px;
  margin-top: 20px;
  @media (max-width: 960px){
    width:100%;
    order: 1;
  }
`;

const CardBigMapContainer = styled(Box)`
  height: 30vh;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #ccc;
  min-height: 300px;
  max-height: 720px;
  @media (max-width: 960px){
    width: 96%;
  }
`;

const CardSmallMapContainer = styled(Box)`
  height: 100%;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #ccc;
`;

const OverlayBaseContainer = styled(Box)`
  /* Reference: https://www.w3schools.com/howto/howto_css_overlay.asp */
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
`

const OverlaySearchEquipmentContainer = styled(Box)`
  background: #DCFFD74D;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  width: 80%;
  height: 90vh;
  position: relative;
`
const SearchEquipmentContainer = styled(Box)`
  height: 90vh;
  border-radius: 10px;
  overflow: auto;
  background-color: #FFFFFF;
  width: 100%;
  position: relative;
`;

const OverlayActiveStyle = {
  display: 'flex',
  // flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center'
}

const OverlayCloseLogo = styled(Box)`
  position: absolute;
  top: 28px;
  right: 28px;
`

const WorkerStatusCard = styled(Card)`
  hight: 100%;
  width: 100%;
  min-height: 400px;
  min-width: 500px;
  overflow: hidden;
  border: 1px solid #ccc;
  border-radius: 12px;
  @media (max-width: 800px){
    //width: 100%;
    max-width: 400px;
    min-width: 200px;
    //align-items: center;
    //justify-content: center;
  }
`

const MapLabelContainer = styled.label`
  width: 120px;
  margin-left: 10px;
  @media (max-width: 1080px) {
    /* Styles for small screens */
    width: 160px;
  }
  flex-wrap: wrap;
  font-size : 12px;
`;
const ReportContainer = styled(Box)`
  margin:28px;
  display: flex;
  // align-items: center;
  height: full;
  border-radius: 20px;
  background-color: white;
  // display:row;
  flex-wrap: wrap;
  // min-width: 320px;
`;
export {
  BackgroundStyle,
  EntryDetailStyle,
  NavyButton,
  BlueButton,
  LightBlueContainer,
  BigHeading,
  SmallHeading,
  HeadingTitle,
  WorkerDetailTextField,
  EntryTextField,
  MapContainer,
  SmallMapContainer,
  ListContainer,
  LongBlueButton,
  RecordTableContainer,
  FlexContainer,
  SearchingBoxContainer,
  BlueBox,
  SearchContainer,
  HidddenButtonContainer,
  LabelContainer,
  RedButton,
  NavigationContainer,
  NavigationSideContainer,
  BackButton,
  ShortBlueButton,
  BarContainer,
  WhiteContainer,
  BarLabel,
  DocumentButton,
  ButtonContainer,
  LongLabelContainer,
  StyledLink,
  StyledIconButton,
  WorkDetailContainer,
  FormWhiteContainer,
  MapBigCardContainer,
  MapBigBoxContainer,
  MapBigMapBoxContainer,
  CardBigMapContainer,
  MapSmallMapBoxContainer,
  CardSmallMapContainer,
  MapSmallCardContainer,
  DeleteButton,
  AddEquipmentButton,
  OverlayBaseContainer,
  OverlaySearchEquipmentContainer,
  OverlayActiveStyle,
  SearchEquipmentContainer,
  OverlayCloseLogo,
  WorkerStatusCard,
  MapLabelContainer,
  ReportContainer
};